import type { AnnotationType } from '@/core/annotationTypes'

export const annotationType: AnnotationType = 'skeleton'
